import React from "react";
import { getRandomStaffData } from "../helpers/dataHelper";

function ChatIcon() {
    const randomContact = getRandomStaffData("Contact", "Marketing");
    const whatsappLink = `https://wa.me/6${randomContact}`;
    return (
        <a href={whatsappLink} target="_blank" rel="noopener noreferrer">
        <img
            src="assets/img/WhatsApp.svg.webp"
            alt="WhatsApp Icon"
            style={{
            position: 'fixed',
            bottom: '20px',
            right: '20px',
            width: '50px',
            height: '50px',
            borderRadius: '50%',
            boxShadow: '0 2px 5px rgba(0, 0, 0, 0.3)',
            zIndex: '9999',
            }}
        />
        </a>
    )
}
export default ChatIcon;